import React, { useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import FormInput from "../../../utils/FormInput";
import "./style/finalizeNoLoginStyle.scss";
import "../../../style/feature.scss";
import "../../../style/typography.scss";
import InvoiceButtons from "./InvoiceButtons";
import { FormElementModel } from "../../models/FormElementModel";
import { invoiceForm, userPayForm, } from "./inputsForm/InputPayFormModels";
import { userPayCheckboxForm } from "./inputsForm/CheckboxPayFormModel";
import BasketSummary from "./BasketSummary";
import { useSelector } from "react-redux";
import { State } from "../../store";
import LoadingSpinner from "../../../features/Loading/LoadingSpinner";
import { PaymentLogos } from "../../../features/PaymentLogo";
import Timer from "./Timer";
import { useTranslation } from "react-i18next";
import ReactPixel from "react-facebook-pixel";
import useFacility from "../../../utils/hooks/useFacility";
import RecipientAndPurchaserForm from "./RecipientAndPurchaserForm";
import { FinalizeRecipient } from "../../models/FinalizeRecipient";
import { gaEvent } from "../../models/ga";
import CheckBoxNewsletter from "./inputsForm/CheckBoxNewsletter";

export type InputsFinalize = {
  firstName: string;
  lastName: string;
  email: string;
  repeatEmail: string;
  phone: string;
  city: string;
  street: string;
  houseNumber: string;
  flatNumber: string;
  zipCode: string;
  NIP: string;
  companyName: string;
  createUser: boolean;
  createInvoice: boolean;
  acceptEAktywni: boolean;
  acceptPrivacyPolicy: boolean;
  acceptStatute: boolean;
  recipient?: FinalizeRecipient;
  purchaser?: FinalizeRecipient;
};

interface IProps {
  onPayTransaction: (value: InputsFinalize) => void;
  onSaveReservation: (value: InputsFinalize) => void;
  alert: string;
  total: number;
  paymentUrl: string;
  loader: boolean;
}

const FinalizeNoLogin: React.FC<IProps> = ({
  onPayTransaction,
  onSaveReservation,
  alert,
  total,
  paymentUrl,
  loader,
}: IProps) => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { t } = useTranslation();

  const [invoiceType, setInvoiceType] = useState<
    "noInvoice" | "customerInvoice" | "companyInvoice" | "recipientAndPurchaserInvoice"
  >("noInvoice");
  const {
    register,
    watch,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm<InputsFinalize>({});
  const zipCodeRequired = useSelector((state: State) => state.config.configuration.zipCodeRequired);
  const phoneNumberRequired = useSelector((state: State) => state.config.configuration.phoneNumberRequired);
  const facilityIds = useFacility();
  const [email, setEmail] = useState<string>();
  const handleRegistration: SubmitHandler<InputsFinalize> = async (data) => {
    if (invoiceType === "recipientAndPurchaserInvoice") {
      onSaveReservation({ ...data, createInvoice: true });
    } else {
      onPayTransaction({ ...data, createInvoice: invoiceType !== "noInvoice" });
    }
    setEmail(data.email);
    pixelAddBasket();
  };

  const pixelAddBasket = () => {
    if (facilityIds === "273" || facilityIds === "1224" || facilityIds === "1200" || facilityIds === "1204" || facilityIds === "1227" || facilityIds === "1214") {
      ReactPixel.fbq("track", "basketValueBeforePayU", {
        value: total,
        currency: "PLN",
      });
      gaEvent(
        "...",
        "purchase",
        {
          value: total,
          currency: "PLN",
        },
        ""
      );

      // lista itemów name / price /qnt
      // transaction_id
    }
  };

  return (
    <div>
      <form className="finalize-no-login flex-between" onSubmit={handleSubmit(handleRegistration)}>
        <div className="padding-big box shadow border">
          <h3>{t("dane_zamawiajacego")}</h3>

          {userPayForm(watch, register, zipCodeRequired, phoneNumberRequired).map(
            (item: FormElementModel, index: number) => (
              <FormInput key={index} {...item} errors={errors} />
            )
          )}

          {saleConfiguration.invoiceActive && (
            <React.Fragment>
              <h3>{t("faktura")}</h3>
              <InvoiceButtons invoiceType={invoiceType} setInvoiceType={setInvoiceType} />
            </React.Fragment>
          )}
        </div>

        <div className="padding-big box shadow border">
          {invoiceType !== "noInvoice" && (
            <div>
              {invoiceType === "recipientAndPurchaserInvoice" ? (
                <RecipientAndPurchaserForm register={register} errors={errors} />
              ) : (
                <>
                  {" "}
                  <h3>{t("dane_do_faktury")}</h3>
                  <div className={"inputs-customer-invoice"}>
                    {invoiceForm(register, invoiceType === "companyInvoice").map(
                      (item: FormElementModel, index: number) =>
                        item.name && <FormInput key={index} {...item} errors={errors} />
                    )}
                  </div>
                </>
              )}
            </div>
          )}

          {invoiceType === "noInvoice" && (
            <div>
              <h3>{t("zgody")}</h3>
              {userPayCheckboxForm(errors, control, setValue).map((item, index) => (
                <div className="flex-start-center" key={index}>
                  {item}
                </div>
              ))}

              {facilityIds === "1228" && <CheckBoxNewsletter email={email} />}
            </div>
          )}
        </div>

        <div className="padding-big box shadow border">
          {invoiceType !== "noInvoice" && (
            <div>
              <h3>{t("zgody")}</h3>
              {userPayCheckboxForm(errors, control, setValue).map((item, index) => (
                <div className="flex-start-center" key={index}>
                  {item}
                </div>
              ))}
              {facilityIds === "1228" && <CheckBoxNewsletter email={email} />}
            </div>
          )}

          <BasketSummary total={total} />

          {alert.length > 2 && <div className="alert alert-red">{alert}</div>}
          {/* <input
            className={"button button-fill-second big full-button move-up"}
            type={"submit"}
            value={"Kupuję i płacę"}
          /> */}

          {!loader ? (
            <React.Fragment>
              {paymentUrl === "" ? (
                <input
                  className={"button button-fill-second big full-button move-up"}
                  type={"submit"}
                  value={t("kupuje_z_obowiazkiem_zaplaty")}
                />
              ) : (
                <React.Fragment>
                  {paymentUrl && (
                    <a target="_blank" className="button button-fill-second big full-button move-up" href={paymentUrl}>
                      {" "}
                      {t("przejdz_do_platnosci")}
                    </a>
                  )}

                  <span className="small-akapit">
                    {t("za_chwile_zostaniesz_automatycznie_przeniesiony_do_systemu_platnosci")}
                  </span>
                </React.Fragment>
              )}
            </React.Fragment>
          ) : (
            <LoadingSpinner />
          )}
          <Timer />

          <PaymentLogos />
        </div>
      </form>
    </div>
  );
};

export default FinalizeNoLogin;
